export function getFooterLiterals(t: any) {
    return {
      title: t("footer.title"),
      showPrivacyPolicyText: t("footer.showPrivacyPolicyText"),
      showLegalConditionsText: t("footer.showLegalConditionsText"),
      showCookiePolicyText: t("footer.showCookiePolicyText"),
      linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
      linkLegalConditionsText:
        "https://www.docomobility.com/es/terminos-y-condiciones",
      linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
    };
  }
  export function getPageLiterals(t: any) {
    return {
      title: t("title"),
      backToOutwardJourneyText: t("backToOutwardJourneyText"),
      backToReturnJourneyText: t("backToReturnJourneyText"),
      aboutPayment: t("aboutPayment"),
      addPaymentCard: t("addPaymentCard"),
      tcTitle: t("tcTitle"),
      tcAccept: t("tcAccept"),
      seeMoreInfo: t("seeMoreInfo"),
      totalTravel: t("totalTravel"),
      altInfoTotal: t("altInfoTotal"),
      payNow: t("payNow"),
      pay: t("pay"),
      reservePostPagoInfo: t("reservePostPagoInfo"),
      finish: t("finish"),
      approx: t("approx"),
      saveNow:  t("saveNow"),
      paymentBox:{
        paidTrip:t("paymentBox.paidTrip"),
        reserve:t("paymentBox.reserve"),
        failed:t("paymentBox.failed"),
        waitingPayment:t("paymentBox.waitingPayment"),
        valid:t("paymentBox.valid"),
        titleValidDisclaimer:t("paymentBox.titleValidDisclaimer"),
        titleFailedDisclaimer:t("paymentBox.titleFailedDisclaimer"),
        applyDiscount:t("paymentBox.applyDiscount"),
        pending:t("paymentBox.pending"),
      },
      addDiscountCode: t("addDiscountCode"),
      desgloseModal: {
        title: t("desgloseModal.title"),
        altCloseModal: t("desgloseModal.altCloseModal"),
        departureJourney: t("desgloseModal.departureJourney"),
        arrivalJourney: t("desgloseModal.arrivalJourney"),
        externalBuy: t("desgloseModal.externalBuy"),
        altExternalBuy: t("desgloseModal.altExternalBuy"),
        tooltipText: t("desgloseModal.tooltipText"),
        payNow: t("desgloseModal.payNow"),
        payLater: t("desgloseModal.payLater"),
        payTotal: t("desgloseModal.payTotal"),
        canceled: t("desgloseModal.canceled"),
        reserved: t("desgloseModal.reserved"),
        noReserved: t("desgloseModal.noReserved"),
        payDeparture: t("desgloseModal.payDeparture"),
        payReturn: t("desgloseModal.payReturn"),
        onlyOutwardTrip: t("desgloseModal.onlyOutwardTrip"),
        discount: t("desgloseModal.discount"),
        boltDisclamer: t("boltDisclamer"),
        outwardBreakdown:t("desgloseModal.outwardBreakdown"),
        returnBreakdown:t("desgloseModal.returnBreakdown"),
        showBreakDown:t("desgloseModal.showBreakDown"),
        buttonBreakDown:t("desgloseModal.buttonBreakDown"),
      },
      promoCode: {
        title: t("promoCode.title"),
        desc1: t("promoCode.desc1"),
        desc2: t("promoCode.desc2"),
        desc3: t("promoCode.desc3"),
        desc4: t("promoCode.desc4"),
        inputTitle: t("promoCode.inputTitle"),
        button: t("promoCode.button"),
        error: t("promoCode.error"),
        applyDiscount:t("promoCode.applyDiscount"),
        discountsAvailable:{
         title: t("promoCode.discountsAvailable.title"), 
         card: {
              eurDiscount:t("promoCode.discountsAvailable.card.eurDiscount"),
              validityDate:t("promoCode.discountsAvailable.card.validityDate"),
              points:t("promoCode.discountsAvailable.card.points"),
          },
          toast: {
              title: t("promoCode.discountsAvailable.toast.title"),
              subtitle: t("promoCode.discountsAvailable.toast.subtitle"),
          }
        }
      },
      expiredText: t("expiredText"),
      boltDisclamer: t("boltDisclamer"),
    };
  }
  export function getPrivatePolicyLiterals(t: any) {
    return {
      titleComments: t("titleComments"),
      Movitaxi: {
        title: t("moviTaxiTitle"),
        urlMovitaxiTCs: t("urlMovitaxiTCs"),
        urlMovitaxiPoliPri: t("urlMovitaxiPoliPri"),
      },
      Reby: {
        title: t("rebyTitle"),
        urlRebyTCs: t("urlRebyTCs"),
        urlRebyPoliPri: t("urlRebyPoliPri"),
      },
      Cooltra: {
        title: t("cooltraTitle"),
        urlCooltraTCs: t("urlCooltraTCs"),
        urlCooltraPoliPri: t("urlCooltraPoliPri"),
      },
      Karhoo: {
        title: t("karhooTitle"),
        urlKarhooTCs: t("urlKarhooTCs"),
        urlKarhooPoliPri: t("urlKarhooPoliPri"),
      },
      Renfe: {
        title: t("renfeTitle"),
        urlRenfeCondViajero: t("urlRenfeCondViajero"),
        urlRenfeCondVenta: t("urlRenfeCondVenta"),
        urlRenfePoliPri: t("urlRenfePoliPri"),
        urlRenfeInfLegal: t("urlRenfeInfLegal"),
      },
  
      Bolt: {
        title: t("boltTitle"),
        urlBoltTCs: t("urlBoltTCs"),
        urlBoltPoliPri: t("urlBoltPoliPri"),
      },
  
      Tier: {
        title: t("tierTitle"),
        urlTierTCs: t("urlTierTCs"),
        urlTierPoliPri: t("urlTierPoliPri"),
      },
      FreeNow: {
        title: t("freeNowTitle"),
        urlFreeNowTCs: t("urlFreeNowTCs"),
        urlFreeNowPoliPri: t("urlFreeNowPoliPri"),
        urlFreeNowChargingPolicy: t("urlFreeNowChargingPolicy"),
      },
      terCond: t("terCond"),
      poliPriv: t("poliPriv"),
      condicGenViaje: t("condicGenViaje"),
      condicGenVenta: t("condicGenVenta"),
      infoLegal: t("infoLegal"),
      descMessage: t("descMessage"),
      title: t("title"),
      buttonCancelar: t("buttonCancelar"),
      buttonAccept: t("buttonAccept"),
      chargePolicy:t("chargePolicy"),
    };
  }
  
  export function getUserHasDebtsModalLiterals(t: any) {
    return {
      title: t("getUserHasDebtsModalLiterals.title"),
      desc: t("getUserHasDebtsModalLiterals.desc"),
      confirmButton: t("getUserHasDebtsModalLiterals.confirmButton"),
    };
  }
  export function getUpdatedTarifModalLiterals(t: any) {
    return {
      title: t("getTarifUpdatedModalLiterals.title"),
      desc: t("getTarifUpdatedModalLiterals.desc"),
      okbutton: t("getTarifUpdatedModalLiterals.confirmButton"),
    };
  }
  
  export function getCheckTimeoutTaxiLiterals(t: any) {
    return {
      title: t("getCheckTimeoutTaxiLiterals.title"),
      desc: t("getCheckTimeoutTaxiLiterals.desc"),
      confirmButton: t("getCheckTimeoutTaxiLiterals.confirmButton"),
    };
  }
  export function getInfoBoltLiterals(t: any) {
    return {
      title: t("getInfoBoltLiterals.title"),
      desc: t("getInfoBoltLiterals.desc"),
      confirmButton: t("getInfoBoltLiterals.confirmButton"),
    };
  }
  export function getProvisionCardLiterals(t: any) {
    return {
      title: t("getProvisionCardLiterals.title"),
      desc: t("getProvisionCardLiterals.desc"),
      okButton: t("getProvisionCardLiterals.okButton"),
      cancelButton: t("getProvisionCardLiterals.cancelButton"),
    };
  }

  
  
  export function getPaymentMethodModalLiterals(t: any) {
    return {
      title: t("getPaymentMethodModalLiterals.title"),
      subtitle: t("getPaymentMethodModalLiterals.subtitle"),
      cancelButton: t("getPaymentMethodModalLiterals.cancelButton"),
      addButton: t("getPaymentMethodModalLiterals.addButton"),
      expirationWarningText: t("getPaymentMethodModalLiterals.expirationWarningText"),
    };
  }
  
  export function getDiscountWorthLiterals(t: any) {
    return {
      title: t("getDiscountWorthLiterals.title"),
      desc: t("getDiscountWorthLiterals.desc"),
      okButton: t("getDiscountWorthLiterals.okButton"),
      cancelButton: t("getDiscountWorthLiterals.cancelButton"),
    };
  }
  export function getDiscountNoAppliedLiterals(t: any) {
    return {
      title: t("getDiscountNoAppliedLiterals.title"),
      desc: t("getDiscountNoAppliedLiterals.desc"),
      okButton: t("getDiscountNoAppliedLiterals.okButton"),
      cancelButton: t("getDiscountNoAppliedLiterals.cancelButton"),
    };
  }
  
  export function getRemoveDiscountLiterals(t: any) {
    return {
      title: t("getRemoveDiscountLiterals.title"),
      desc: t("getRemoveDiscountLiterals.desc"),
      okButton: t("getRemoveDiscountLiterals.okButton"),
      cancelButton: t("getRemoveDiscountLiterals.cancelButton"),
    };
  }
  
  export function getDiscountCardLiterals(t: any) {
    return {
      priceDiscount: t("getDiscountCardLiterals.priceDiscount"),
      deleteButton: t("getDiscountCardLiterals.deleteButton"),
    };
  }
  
  export function getMessageExpiredModal(t: any) {
    return {
      title: t("getMessageExpiredModal.title"),
      description: t("getMessageExpiredModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("getMessageExpiredModal.buttons.0.text"),
        },
      ],
    };
  }
  
  export function getChangePaymentMethod(t: any) {
    return {
      stateCard: t("getChangePaymentMethod.stateCard"),
    };
  }


  /* Mocks */
export function mockSummary() {
    return [
      {
        text: "Ida",
        price: "61,50 €",
        priceNumber: 61.5033,
        departure: "Plaza de la Seo, 4, Zaragoza",
        arrival: "Calle Arribas, 1, Valladolid",
        date: "18 ene",
        rangetime: "11:45 - 16:00",
        num: "1",
      },
      {
        text: "Vuelta",
        price: "48,00 €",
        priceNumber: 48.11111,
        departure: "Calle Arribas, 1, Valladolid",
        arrival: "Plaza de la Seo, 4, Zaragoza",
        date: "20 ene",
        rangetime: "9:45 - 13:00",
        num: "4",
      },
    ];
  }
  export function mockDeparture() {
    return {
      transports: [
        {
          transport: "Autobús urbano",
          details: [
            {
              text: "Billete a Estación de autobuses Zaragoza",
              external: true,
            },
          ],
        },
        {
          transport: "AVE Larga distancia",
          details: [
            {
              text: "AVE 19730 Zaragoza - Madrid",
              price: "49,50 €",
            },
            {
              text: "Cercanías C1 Atocha - Chamartín",
              price: "0,00 €",
            },
            {
              text: "AVE 19730 Madrid - Valladolid",
              price: "40,50 €",
            },
          ],
        },
        {
          transport: "Metro",
          details: [
            {
              text: "Billete a Chamartín",
              external: true,
            },
          ],
        },
      ],
      desglose: {
        now: "90,00 €",
        later: "0,00 €",
        total: "90,00 €",
      },
    };
  }
  export function mockArrival() {
    return {
      transports: [
        {
          transport: "Autobús urbano",
          details: [
            {
              text: "Billete a Valdefierro",
              external: true,
            },
          ],
        },
        {
          transport: "AVE Larga distancia",
          details: [
            {
              text: "AVE 19730 Zaragoza - Madrid",
              price: "49,90 €",
            },
            {
              text: "Cercanías C1 Atocha - Chamartín",
              price: "0,00 €",
            },
            {
              text: "AVE 19730 Madrid - Valladolid",
              price: "39,50 €",
            },
          ],
        },
        {
          transport: "Metro",
          details: [
            {
              text: "Billete a Chamartín",
              external: true,
            },
          ],
        },
        {
          transport: "Reby",
          price: "aprox 4,20 €",
        },
      ],
      desglose: {
        now: "19,50 €",
        later: "0,00 €",
        total: "19,50 €",
      },
    };
  }
  export function mockPost() {
    return {
      outwardJourney: {
        trip: {
          Eco: {
            co2: 0.99781500000000001,
            rating: 0,
          },
          Origin: {
            extId: "100018101",
            time: "08:00:00",
            id: "A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@",
            lon: -3.703214,
            date: "2022-08-18",
            lat: 40.416876999999999,
            type: "ST",
            name: "Calle de Salvador Dalí, 4",
          },
          LegList: {
            Leg: [
              {
                Origin: {
                  extId: "100018101",
                  time: "08:00:00",
                  id: "A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@",
                  lon: -3.703214,
                  date: "2022-08-18",
                  lat: 40.416876999999999,
                  type: "ST",
                  name: "Calle de Salvador Dalí, 4",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@|A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@|18082022|80000|80900|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
                },
                Destination: {
                  extId: "200001170",
                  time: "08:09:00",
                  id: "A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@",
                  lon: -3.6951689999999999,
                  date: "2022-08-18",
                  lat: 40.391896000000003,
                  type: "ST",
                  name: "Legazpi",
                },
                Product: [
                  {
                    name: "bolt",
                  },
                ],
                idx: 0,
                type: "TAXI",
                name: "bolt",
              },
            ],
          },
          checksum: "2a8b1c18_3",
          Destination: {
            extId: "200001170",
            time: "08:09:00",
            id: "A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@",
            lon: -3.6951689999999999,
            date: "2022-08-18",
            lat: 40.391896000000003,
            type: "ST",
            name: "Legazpi",
          },
          TariffResult: {
            fareSetItem: [
              {
                param: [
                  {
                    name: "NAME",
                    value: "Movitaxi Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:0",
                  },
                  {
                    name: "secIds",
                    value: "C-0:0",
                  },
                ],
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHhNQ0lzSW1KMVpHZGxkRWxrSWpvaU9URmpNek5sWmpjdE16QmxNaTAwTURnekxUaGhaall0T1RVNU1qUTFOekE1TkdJeEluMD0=",
                          provider: "taxi",
                          contentType: "XBOOK_CTX",
                          text: "Ver oferta",
                        },
                        cur: "EUR",
                        name: "Movitaxi ticket",
                        price: 1268,
                        shpCtx:
                          "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
                      },
                    ],
                  },
                ],
                toLegId: 0,
                name: "Movitaxi Pricing",
                fromLegId: 0,
              },
            ],
          },
        },
        selectedTariff: [
          {
            idLeg: 0,
            provider: "bolt",
            contextType: "BOOKEE_CONTEXT",
            tickets: [
              {
                context:
                  "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
              },
            ],
          },
        ],
      },
      travellers: [
        {
          type: "ADULT",
        },
        {
          type: "CHILD",
        },
        {
          type: "BABY",
        },
      ],
    };
  }

  export function getRouteDiscountLiterals(t: any, price?: any) {
    let title =t("routeDiscount.title");
    return {
      titleStep1: t("routeDiscount.titleStep1"),
      titleStep2: t("routeDiscount.titleStep2"),
      descStep1: t("routeDiscount.descStep1"),
      descStep2: t("routeDiscount.descStep2"),
      okButton: t("routeDiscount.okButton"),
      cancelButton: t("routeDiscount.cancelButton"),
      titleMiniStep: t("routeDiscount.titleMiniStep"),
      promoCode: {
        title: t("promoCode.title"),
        desc1: t("promoCode.desc1"),
        desc2: t("promoCode.desc2"),
        desc3: t("promoCode.desc3"),
        desc4: t("promoCode.desc4"),
        inputTitle: t("promoCode.inputTitle"),
        button: t("promoCode.button"),
        error: t("promoCode.error"),
        applyDiscount: t("promoCode.applyDiscount"),
        warning: t("promoCode.warning"),
        discountsAvailable:{
          title: t("promoCode.discountsAvailable.title"), 
          getDiscount:t("promoCode.discountsAvailable.getDiscount"),
          card: {
               eurDiscount:t("promoCode.discountsAvailable.card.eurDiscount"),
               validityDate:t("promoCode.discountsAvailable.card.validityDate"),
               points:t("promoCode.discountsAvailable.card.points"),
           },
           toast: {
               title: t("promoCode.discountsAvailable.toast.title"),
               subtitle: t("promoCode.discountsAvailable.toast.subtitle"),
           }
         },
        alertNotChecked: t("promoCode.alertNotChecked"),
      },
    };
  }
  
  export function getModalErrorDiscountLiterals(t: any) {
    return {
      title: t("modalErrorDiscount.title"),
      descFirst: t("modalErrorDiscount.descFirst"),
      descSecond: t("modalErrorDiscount.descSecond"),
      okButton: t("modalErrorDiscount.okButton"),
    };
  }
  
  export function getModalErrorMethodPaymentLiterals(t: any) {
    return {
      title: t("modalErrorMethodPayment.title"),
      descFirst: t("modalErrorMethodPayment.descFirst"),
      okButton: t("modalErrorMethodPayment.okButton"),
    };
  }
  
  export function getModalErrorPoliciestLiterals(t: any) {
    return {
      title: t("modalErrorPoliciesLiterals.title"),
      descFirst: t("modalErrorPoliciesLiterals.descFirst"),
      okButton: t("modalErrorPoliciesLiterals.okButton"),
    };
  }
  
  
  export function getErrorPointsLiterals(t: any) {
    return {
      getErrorPoints: {
        getServiceErrorPointsLiterals:{
        title: t("getErrorPoints.getServiceErrorPointsLiterals.title"),
        description: t("getErrorPoints.getServiceErrorPointsLiterals.description"),
        buttons: [
          {
            text: t("getErrorPoints.getServiceErrorPointsLiterals.buttons.0.text"),
            styleButton: "outline",
          }
        ]
      },
      getErrorNoPointsLiterals:{
        title: t("getErrorPoints.getErrorNoPointsLiterals.title"),
        description: t("getErrorPoints.getErrorNoPointsLiterals.description"),
      }
    }
    }
  }
  
  export function getLiteralTripInformative(t: any) {
    return {
      imageSection: {
        url:  t("getLiteralTripInformative.imageSection.url"),
        width: t("getLiteralTripInformative.imageSection.width"),
        height: t("getLiteralTripInformative.imageSection.height"),
        name:  t("getLiteralTripInformative.imageSection.name"),
      },
      title: t("getLiteralTripInformative.title"),
      description: t("getLiteralTripInformative.description"),
      description2:t("getLiteralTripInformative.description2"),
  
    }
  }


  export function getModaInfoPay(t: any,status:any) {
    let result={}
    switch (status) {
      case 'WAITING_PAYMENT':
        result={
          title: t("getModaInfoPay.waitingPayment.title"),
          desc: t("getModaInfoPay.waitingPayment.desc"),
          confirmButton: t("getModaInfoPay.waitingPayment.confirmButton"),
        }
        break;

       case 'VALID':
          result={
            title: t("getModaInfoPay.valid.title"),
            desc: t("getModaInfoPay.valid.desc"),
            confirmButton: t("getModaInfoPay.valid.confirmButton"),
          }
          break;
    
      default:
        break;
    }
    return result
  }

    export function getDontPayGoogleApple(t: any) {
    return {
      title: t("getDontPayGoogleApple.title"),
      description: t("getDontPayGoogleApple.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("getMessageExpiredModal.buttons.0.text"),
        },
      ],
    };
  }

    export function getConfirmFinishProcessLiterals(t: any) {
    return {
      title: t("getConfirmFinishProcessLiterals.title"),
      desc: t("getConfirmFinishProcessLiterals.desc"),
      okButton: t("getConfirmFinishProcessLiterals.okButton"),
      cancelButton: t("getConfirmFinishProcessLiterals.cancelButton"),
    };
  }
  

  